module.exports = require("core-js/modules/es.function.name.js");